import React from "react";
import logo from "../../assets/logo.jpg";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const pinp = "w-full text-base sm:text-sm rounded-xl border border-slate-300 bg-white px-3.5 py-3 sm:py-2.5 text-slate-900 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-100";
export const TYPE_ZH = { old_customer: ["老客户", "Past customer"], realtor: ["地产经纪人", "Realtor"], insurance_agent: ["保险经纪人", "Insurance agent"] };

export async function pfetch(path, opts) {
  const r = await fetch(`${BACKEND}/api${path}`, { headers: { "Content-Type": "application/json", ...(opts?.headers || {}) }, ...opts });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : Array.isArray(j.detail) ? j.detail.map((x) => x.msg).join(" ") : `Error ${r.status}`);
  return j;
}

export function PublicShell({ children, lang, setLang, title, subtitle, tid }) {
  const zh = lang === "zh";
  return (
    <div className="min-h-screen bg-[#f6f8fe] text-slate-900" data-testid={tid} data-lang={lang}>
      <div className="max-w-xl mx-auto px-4 py-6 sm:py-10">
        <header className="flex items-center gap-3 mb-6">
          <img src={logo} alt="ALIGCUS" className="h-11 w-11 rounded-xl object-cover" />
          <div className="min-w-0">
            <p className="text-[11px] tracking-widest text-indigo-500 font-semibold">ALIGCUS · 阿里建筑</p>
            <h1 className="text-lg sm:text-xl font-bold leading-tight">{title}</h1>
            {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
          </div>
          {setLang && (
            <div className="ml-auto inline-flex rounded-full border border-slate-200 bg-white p-0.5 text-xs" data-testid={`${tid}-lang`}>
              <button data-testid={`${tid}-lang-zh`} onClick={() => setLang("zh")} className={`px-2.5 py-1 rounded-full ${zh ? "bg-indigo-600 text-white" : "text-slate-600"}`}>中文</button>
              <button data-testid={`${tid}-lang-en`} onClick={() => setLang("en")} className={`px-2.5 py-1 rounded-full ${!zh ? "bg-indigo-600 text-white" : "text-slate-600"}`}>EN</button>
            </div>
          )}
        </header>
        {children}
        <footer className="mt-10 text-[11px] text-slate-400 text-center">© ALIGCUS · <a href="/privacy" className="underline">Privacy</a> · <a href="/terms" className="underline">Terms</a></footer>
      </div>
    </div>
  );
}
